<template>
  <article class="register-confirmation" v-if="loaded">
    <dr-vector
      class="register-confirmation__logo"
      :fill="'blue'"
      src="@/assets/img/logo-branco.svg"
    />

    <div class="register-confirmation__success" v-if="this.success">
      <big><strong>Email confirmado com sucesso!</strong></big>

      <dr-loader class="register-confirmation__loader" size="lg" />
    </div>

    <div class="register-confirmation__failed" v-else>
      <h1>Ocorreu um erro</h1>

      <p>
        Código inválido ou não encontrado no sistema.
        <br>
        Por favor, entre em contato com a administração.
      </p>

      <router-link to='/login' class="btn btn-primary">
        Ir para o login
      </router-link>
    </div>
  </article>
</template>

<script>
export default {
  data () {
    return {
      loaded: false,
      success: false
    }
  },
  mounted () {
    // Facebook tracking code
    window.fbq('init', '532918017596757')
    window.fbq('track', 'DoctorConfirmEmail')

    this.fn_SHOW_PROGRESS()
    const url = `/doctor/register_confirmation/${this.$route.params.token}`
    const method = 'get'
    this.$http({
      url,
      method,
      validateStatus: (status) => true
    })
      .then((res) => {
        if (res.status === 200) {
          this.success = true
          setTimeout(() => {
            this.$store.dispatch('setAuth', {token: res.data.token})
            this.$router.push('/doctor')
          }, 5000)
        }
        if (res.status === 404) {
          this.success = false
        }
        if (res.status === 400) {
          this.$router.push('/login')
        }
      })
      .catch(err => console.log(err))
      .finally(() => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      })
  }
}
</script>
